<template>
  <div class="gradient"></div>
</template>

<style scoped lang="scss">
.gradient {
  z-index: 50;
  opacity: 0.4;
  pointer-events: none;
  width: 100%;
  height: 9rem;
  position: absolute;
  mix-blend-mode: normal;
  background: linear-gradient(
    180deg,
    rgba(5, 49, 77, 1) 0%,
    rgba(9, 89, 139, 0) 100%
  );
}
</style>
